import React from 'react';
import { Container, Typography, Box, Button } from '@mui/material';
import { Link } from 'react-router-dom';

const HomePage = () => {
  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
      <Box textAlign="center">
        <Typography variant="h2" gutterBottom>
          Trading Screener
        </Typography>
        <Typography variant="h5" color="text.secondary" gutterBottom>
          AI-powered stock screening with ANTLR query language
        </Typography>
        <Button 
          component={Link} 
          to="/screener" 
          variant="contained" 
          size="large"
          sx={{ mt: 2 }}
        >
          Start Screening
        </Button>
      </Box>
    </Container>
  );
};

export default HomePage;